/*
 * ANANDA Card Stack — depth-cue scale, driven by Motion (motion.dev).
 *
 * IMPORTANT: the stacking itself is 100% CSS `position: sticky` (see
 * ananda-card-stack.css). This script does NOT control scroll, does NOT
 * pin anything, and does NOT add scroll distance. It only adds the
 * subtle "covered cards shrink a little" depth cue that both reference
 * demos use — so the experience stays compositor-smooth on mobile.
 *
 * Why Motion and not GSAP ScrollTrigger here: we only need a cheap
 * per-frame scroll tick. Motion.scroll gives us exactly that (passive,
 * rAF-batched, and it uses the native ScrollTimeline where available,
 * falling back to scroll events on iOS Safari). The previous GSAP pin is
 * gone entirely.
 *
 * The shrink amount is read from LIVE element geometry every frame, so
 * it's automatically correct regardless of header height, Lenis
 * smooth-scroll, viewport resizes, or how many cards there are.
 *
 * Last-card join (2026-06-03): the final card has nothing rising over it,
 * so it used to stay full size. It now shrinks over the "tail" runway
 * (the list's padding-bottom) once it reaches its sticky rest, so it
 * settles INTO the stack like the others — Roi's request.
 */
(function () {
  function ready(cb) {
    if (window.Motion && window.Motion.scroll) return cb();
    var tries = 0;
    var iv = setInterval(function () {
      if (window.Motion && window.Motion.scroll) { clearInterval(iv); cb(); }
      else if (++tries > 60) { clearInterval(iv); /* CSS stacking still works */ }
    }, 50);
  }

  function headerHeight() {
    var sel = [
      'sticky-header', 'header-component', '#shopify-section-header',
      '.section-header', '.header-wrapper', 'header.header'
    ];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el && el.offsetHeight > 0) return el.offsetHeight;
    }
    return window.matchMedia('(max-width: 749px)').matches ? 70 : 80;
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sections = document.querySelectorAll('[data-ananda-card-stack]');
    if (!sections.length) return;

    var h = headerHeight();

    sections.forEach(function (section) {
      if (section.dataset.csInit === '1') return;
      section.dataset.csInit = '1';

      // Refine the sticky rest-point to the real header height (no jump:
      // sticky `top` changes don't reflow the document).
      section.style.setProperty('--ananda-cs-header', h + 'px');

      var cards = Array.prototype.slice.call(
        section.querySelectorAll('[data-ananda-card-stack-card]')
      );
      if (cards.length < 2) return;

      var inners = cards.map(function (c) {
        return c.querySelector('[data-ananda-card-stack-inner]');
      });
      var list = section.querySelector('[data-ananda-card-stack-list]');

      // Lowest scale a once-covered card reaches (merchant setting).
      var minScale = (parseFloat(section.dataset.backScale) || 92) / 100;

      function update() {
        for (var i = 0; i < cards.length - 1; i++) {
          if (!inners[i]) continue;
          var covered = cards[i].getBoundingClientRect();
          var cover   = cards[i + 1].getBoundingClientRect();
          // t = 0 when the covering card is a full card-height below the
          // covered card's resting top; t = 1 when their tops coincide
          // (fully stacked). Smooth, geometry-based, no magic numbers.
          var span = covered.height || 1;
          var t = 1 - (cover.top - covered.top) / span;
          t = t < 0 ? 0 : (t > 1 ? 1 : t);
          var s = 1 - (1 - minScale) * t;
          inners[i].style.transform = 'scale(' + s.toFixed(4) + ')';
        }

        // The last card has nothing rising over it, so it would normally
        // stay full size on top of the pile. Make it "join the stack" too:
        // once it reaches its sticky rest, the list's bottom keeps rising
        // toward it (through the list's padding-bottom = the "tail") as you
        // scroll on. Map that remaining travel to the same depth-cue shrink
        // the other cards get, so it settles INTO the stack.
        var lastIdx = cards.length - 1;
        var lastInner = inners[lastIdx];
        if (lastInner) {
          var lastRect = cards[lastIdx].getBoundingClientRect();
          var lastSpan = lastRect.height || 1;
          var tailPx = 1;
          if (list) {
            var pb = parseFloat(getComputedStyle(list).paddingBottom);
            if (pb > 0) tailPx = pb;
          }
          var listBottom = list
            ? list.getBoundingClientRect().bottom
            : (lastRect.top + lastSpan + tailPx);
          var lgap = listBottom - (lastRect.top + lastSpan);
          var lt = 1 - lgap / tailPx;
          lt = lt < 0 ? 0 : (lt > 1 ? 1 : lt);
          lastInner.style.transform = 'scale(' + (1 - (1 - minScale) * lt).toFixed(4) + ')';
        }
      }

      // Tick on every scroll frame (Motion handles throttling + the
      // ScrollTimeline / scroll-event fallback). We ignore the progress
      // argument and use live rects instead.
      window.Motion.scroll(update);
      update();
      window.addEventListener('resize', update, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ready(init); });
  } else {
    ready(init);
  }
})();
